import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function TurnsOffIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14"}
      height={height || "14"}
      viewBox="0 0 14 14"
    >
      <g id="Deactivate" transform="translate(-3 -3)">
        <path
          id="Path_10203"
          data-name="Path 10203"
          d="M10.778,3H9.222v7.778h1.556Zm3.757,1.688-1.1,1.1A5.382,5.382,0,0,1,15.444,10,5.444,5.444,0,1,1,6.562,5.784l-1.1-1.1A6.994,6.994,0,1,0,17,10,6.947,6.947,0,0,0,14.534,4.688Z"
          transform="translate(0 0)"
          fill={color || "#c41700"}
        />
      </g>
    </svg>
  );
}
